import $ from 'jquery';
import { init as initProgressDrawer } from './cart-progress-bar-drawer';
function showProgressBar() {
    $('#cart-drawer-progress-bar').css('display', 'block');
    $('#cart-drawer-progress-bar').detach().appendTo('.CartDrawer-titleLink');
//$('#message-container').detach().appendTo('#cart-drawer-gift-option');
}
function showDrawerCart() {
    $('.Offcanvas--right[data-drawer-names="cart"]').addClass('is-expanded');
}
function closeDrawerCart() {
    $('.Offcanvas--right').removeClass('is-expanded');
    $('body').removeClass('is-frozen has-open-offcanvas');
}
function forceOpenMenu() {
    $('.Offcanvas--right').removeClass('is-expanded');
    $('.Offcanvas--left.Offcanvas--menu').removeClass('is-expanded');
    $('.Offcanvas--left.Offcanvas--menu[data-drawer-names="menu"]').addClass('is-expanded');
}
function updateNoteGiftCart(cart_gift, cart_note) {
    const note = cart_note;
    $.ajax({
        type: 'POST',
        url: '/cart/update.json',
        data: {
            note: note,
            attributes: {
                'Is it a gift order': cart_gift
            }
        },
        success: function(data) {
            console.log('success');
        },
        dataType: 'application/json'
    });
}
function updateNoteCart(cart_note) {
    const note = cart_note;
    $.ajax({
        type: 'POST',
        url: '/cart/update.json',
        data: {
            note: note
        },
        success: function(data) {
            console.log('success');
        },
        dataType: 'application/json'
    });
}
function checkInput() {
    let cart_gift;
    if ($('#is-gift').is(':checked')) {
        $('#message-container').show(300);
        cart_gift = 'Yes';
    } else {
        $('#message-container').hide(300);
        cart_gift = 'No';
    }
    const cart_note = ($('#js-cartdrawer-notefield').val() || '').toString();
    updateNoteGiftCart(cart_gift, cart_note);
}
function checkNote() {
    const cart_note = ($('#js-cartdrawer-notefield').val() || '').toString();
    updateNoteCart(cart_note);
}
export const init = async function() {
    $(document).ready(function() {
        $('button.ProductForm-submitButton.o-button, #atc-button').click(showDrawerCart);
        $('button.ProductForm-submitButton.o-button').click(initProgressDrawer);
        $('#menu-toggle').click(forceOpenMenu);
        $('#drawer-close-button').click(closeDrawerCart);
        $('#is-gift').change(checkInput);
        $('#js-cartdrawer-notefield').change(checkNote);
        showProgressBar();
    });
};
